import { LoadingButton } from '@mui/lab';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import useAsyncGoogleSubscribeToWebhook from '../../../../hooks/useAsyncGoogleSubscribeToWebhook';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../../../../store/hooks';
import { requestConfig } from '../../../../store/users';

export default function SubscribeToWebhook() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const { requestStatus, asyncGoogleSubscribeToWebhook, responseBody } =
        useAsyncGoogleSubscribeToWebhook();

    const handleSubscribe = async () => {
        console.log('asyncGoogleSubscribeToWebhook');

        await asyncGoogleSubscribeToWebhook();

        dispatch(requestConfig());
    };

    return (
        <>
            <LoadingButton
                onClick={handleSubscribe}
                variant="outlined"
                loading={requestStatus == RequestStatus.active}
            >
                Enable Synchronization
            </LoadingButton>
            {!!responseBody && (
                <Typography component="p" variant="body2">
                    {responseBody}
                </Typography>
            )}
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
